import type { Translate } from "@jti/fe-common";

import {
  getExternalAddressValidationErrorCode,
  hasExternalAddressValidationError,
} from "@checkout-v2/shared/utils/externalAddressValidationErrorUtils";
import { formatCheckoutErrorMessage } from "@checkout-v2/shared/utils/formatCheckoutErrorMessage";

export const getShippingAddressErrorMessage = (error: unknown, translate: Translate): string | undefined => {
  if (!error) {
    return undefined;
  }

  if (hasExternalAddressValidationError(error)) {
    const errorCode = getExternalAddressValidationErrorCode(error);
    return errorCode
      ? translate(`cart.checkout.warning.shipping_address_validation_description.${errorCode}`)
      : translate("cart.checkout.warning.shipping_address_validation_description");
  }

  if (error instanceof Error) {
    return formatCheckoutErrorMessage(error.message) ?? error.message;
  }

  return undefined;
};
